export const zh_HK = {
  '返回': '返回',
  '功放控制': '功放控制',
  '功放控制（已缩放适配一屏）': '功放控制（已缩放适配一屏）',
  '连接状态': '連接状态',
  'MCU连接状态': 'MCU連接状态',
  'Hamlib: Connected': 'Hamlib: Connected',
  'MUC: 未连接': 'MUC: 未連接',
  'Connected': '已連接',
  'Disconnected': '未連接',
  '输出天线：': '輸出天線：',
  '手动选择': '手動選擇',
  '自动选择': '自動選擇',
  '触发模式：': '觸發模式：',
  '接收状态': '接收状态',
  'PPT1': 'PPT1',
  'PPT2': 'PPT2',
  '输入功率触发': '輸入功率觸發',
  '时间': '时间',
  '系统同步': '系统同步',
  '报警信息': '報警信息',
  '设备报警': '設備報警',
  '点击查看详情': '点击查看详情',
  '清除报警': '清除報警',
  '清除报警指令已发送': '清除報警指令已发送',
  '清除报警发送失败': '清除報警发送失败',
  '密码验证': '密碼驗證',
  '请输入密码': '请輸入密碼',
  '提示：密码为 666': '提示：密碼为 666',
  '密码验证成功': '密碼驗證成功',
  '密码错误，请重试': '密碼错誤，请重試',
  '工程参数设置已保存': '工程參數設定已保存',
  '工程参数设置': '工程參數設定',
  '审计日志': '審計日誌',
  '报警日志': '報警日誌',
  '更新审计日志指令已发送': '更新審計日誌指令已发送',
  '更新报警日志指令已发送': '更新報警日誌指令已发送',
  '更新审计日志发送失败': '更新審計日誌发送失败',
  '更新报警日志发送失败': '更新報警日誌发送失败',
  '启用报警信息': '啟用報警信息',
  '按日志类型与精确时间范围查询设备事件': '按日誌类型与精确时间范围查詢設備事件',
  '共 {count} 条': '共 {count} 条',
  '开始时间': '開始时间',
  '结束时间': '結束时间',
  '选择开始时间': '選擇開始时间',
  '选择结束时间': '選擇結束时间',
  '数量': '数量',
  '等级': '等级',
  '消息': '消息',
  '更新': '更新',
  '确认': '確認',
  '取消': '取消',
  '确定': '确定',
  '已连接': '已連接',
  '未连接': '未連接',
  '输入天线1': '輸入天線1',
  '输入天线2': '輸入天線2',
  '输入天线衰减器': '輸入天線衰減器',
  '输入衰减器': '輸入衰減器',
  '功放': '功放',
  '天调': '天调',
  '关闭': '關閉',
  '开启': '開啟',
  '调谐中': '調諧中',
  '调谐失败': '調諧失败',
  '输出天线1': '輸出天線1',
  '输出天线2': '輸出天線2',
  '输出天线3': '輸出天線3',
  '输出天线4': '輸出天線4',
  '假负载': '假負載',
  '频率范围无效': '頻率范围無效',
  '天线配置保存失败': '天線配置保存失败',
  '频段未获取': '頻段未获取',
  'Counter': '計數器',
  'Hamlib': 'Hamlib',
  '滤波器：': '濾波器：',
  '频段：': '頻段：',
  '输入': '輸入',
  '输出': '輸出',
  '反向功率': '反向功率',
  '驻波': '駐波',
  '电压:': '電壓:',
  '电流:': '電流:',
  '功率:': '功率:',
  '温度:': '溫度:',
  '选择频段': '選擇頻段',
  '编辑频段': '编辑頻段',
  '波段电压': '波段電壓',
  '频段名称': '頻段名稱',
  '频段值': '頻段值',
  '当前波段电压：': '当前波段電壓：',
  '波段电压:': '波段電壓:',
  '自动模式': '自動模式',
  '协议模式': '协议模式',
  '功放开启确认': '功放開啟確認',
  '设备请求确认开启功放。': '設備请求確認開啟功放。',
  '更新确认': '更新確認',
  '确认更新': '確認更新',
  '设备检测到可用更新，是否开始下载并安装？': '設備檢測到可用更新，是否開始下載并安裝？',
  '更新进度': '更新進度',
  '正在更新…': '正在更新…',
  '重启确认': '重啟確認',
  '立即重启': '立即重啟',
  '稍后重启': '稍後重啟',
  '更新已安装完成，是否立即重启？': '更新已安裝完成，是否立即重啟？',
  '处理中…': '處理中…',
  '输入正向功率保护': '輸入正向功率保護',
  '输入反向功率保护': '輸入反向功率保護',
  '功放管输入过电压保护': '功放管輸入過電壓保護',
  '功放管输出过电压保护': '功放管輸出過電壓保護',
  '功放输出正向功率保护': '功放輸出正向功率保護',
  '功放管输出反向功率保护': '功放管輸出反向功率保護',
  '过流保护': '過流保護',
  '过压保护': '過压保護',
  '过温保护': '過温保護',
  '高驻波': '高駐波',
  '频率误差过大': '頻率誤差過大',
  '修改天线配置': '修改天線配置',
  '默认名称：{name}。名称留空并保存可恢复默认显示。频率单位为 Hz。': '默認名稱：{name}。名稱留空并保存可恢復默認显示。頻率单位为 Hz。',
  '自定义名称': '自定义名稱',
  '开始频率 (Hz)': '開始頻率 (Hz)',
  '结束频率 (Hz)': '結束頻率 (Hz)',
  '保存': '保存',
  '保存中…': '保存中…',
  '请输入有效的频率（Hz）': '请輸入有效的頻率（Hz）',
  '起始频率不能低于 {min} Hz': '起始頻率不能低于 {min} Hz',
  '结束频率不能低于 {min} Hz': '結束頻率不能低于 {min} Hz',
  '起始频率不能大于结束频率': '起始頻率不能大于結束頻率',
  '电台设置': '电台設定',
  '硬件菜单': '硬件菜单',
  '服务器设置': '服务器設定',
  '端口:': '端口:',
  '波特率:': '波特率:',
  '电台:': '电台:',
  '电台选择': '电台選擇',
  '硬件版本:': '硬件版本:',
  '软件版本:': '軟件版本:',
  '检查更新': '检查更新',
  '串口:': '串口:',
  '连接:': '連接:',
  '重新连接': '重新連接',
  '重启软件': '重啟軟件',
  '配置': '配置',
  'MQTT 配置': 'MQTT 配置',
  '串口选择': '串口選擇',
  '波特率选择': '波特率選擇',
  '共 {count} 个可用串口，点击切换 Hamlib 串口': '共 {count} 个可用串口，点击切换 Hamlib 串口',
  '共 {count} 个可选波特率，点击切换 Hamlib 波特率': '共 {count} 个可选波特率，点击切换 Hamlib 波特率',
  '共 {count} 个 Hamlib 机型': '共 {count} 个 Hamlib 机型',
  '请选择电台': '请選擇电台',
  '设备 ID 无效，无法重启软件': '設備 ID 無效，无法重啟軟件',
  '重启软件指令已发送': '重啟軟件指令已发送',
  '重启软件指令发送失败': '重啟軟件指令发送失败',
  '可更新': '可更新',
  '校准系数': '校準係數',
  '其他': '其他',
  '频段': '頻段',
  '电压校准系数': '電壓校準係數',
  '电流校准系数': '電流校準係數',
  '频率校准系数': '頻率校準係數',
  'VGS校准系数': 'VGS校準係數',
  'DAC参考电压': 'DAC参考電壓',
  '偏置电压': '偏置電壓',
  '截止频率': '截止頻率',
  '输入正向功率校准系数': '輸入正向功率校準係數',
  '输入反向功率校准系数': '輸入反向功率校準係數',
  '输出正向功率校准系数': '輸出正向功率校準係數',
  '输出反向功率校准系数': '輸出反向功率校準係數',
  '功放输入功率校准': '功放輸入功率校準',
  '功放输出功率校准': '功放輸出功率校準',
  '保护电压': '保護電壓',
  '保护电流': '保護電流',
  '保护输入正向功率': '保護輸入正向功率',
  '保护输入反向功率': '保護輸入反向功率',
  '保护输出正向功率': '保護輸出正向功率',
  '保护输出反向功率': '保護輸出反向功率',
  '输入保护驻波比': '輸入保護駐波比',
  '输出保护驻波比': '輸出保護駐波比',
  '保护频率误差': '保護頻率誤差',
  '保护温度': '保護溫度',
  '驻波调谐值': '駐波調諧值',
  'PTT触发电功率': 'PTT觸發电功率',
  '恢复出厂设置': '恢復出廠設定',
  '功能待对接': '功能待对接',
  '天线切换失败': '天線切换失败',
  'Command send/receive log': 'Command send/receive log',
  '输入 <100W': '輸入 <100W',
  '减少 {label}': '减少 {label}',
  '增加 {label}': '增加 {label}',
  '工程参数分页': '工程參數分页',
  '校准参数': '校準參數',
  '电压参数': '電壓參數',
  '保存参数': '保存參數',
  '串口': '串口',
  '波特率': '波特率',
  '请选择串口': '請選擇串口',
  '请选择波特率': '請選擇波特率',
  '请选择rig': '請選擇rig',
  '频段校准系数': '頻段校準係數',
  'vgs:': 'vgs:',
  'vgs频率:': 'vgs頻率:',
  '电压': '電壓',
  '输出正向功率比较电压': '輸出正向功率比較電壓',
  '输出反向功率比较电压': '輸出反向功率比較電壓',
  '输入反向功率比较电压': '輸入反向功率比較電壓',
  '输入正向功率比较电压': '輸入正向功率比較電壓',
  '过流比较电压': '過流比較電壓',
  '功率触发PTT电压': '功率觸發PTT電壓',
  '功放管输入功率比较电压': '功放管輸入功率比較電壓',
  '功放管输出功率比较电压': '功放管輸出功率比較電壓',
  '负载电阻': '負載電阻',
  '频率测量值': '頻率測量值',
  '天调电容选择值': '天調電容選擇值',
  '天调电感选择值': '天調電感選擇值',
  '保护驻波比': '保護駐波比',
  '工程参数设置界面': '工程參數設定界面',
} as const;
